import { render, staticRenderFns } from "./ViewParcelButton.vue?vue&type=template&id=22413686&scoped=true&"
import script from "./ViewParcelButton.vue?vue&type=script&lang=js&"
export * from "./ViewParcelButton.vue?vue&type=script&lang=js&"
import style0 from "./ViewParcelButton.vue?vue&type=style&index=0&id=22413686&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22413686",
  null
  
)

export default component.exports